import * as React from 'react';

function ZoomOutIcon(props) {
    return (
        <svg
        width={32}
        height={32}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        >
        <path d="M10 21v-2h20v2H10Z" fill="#000" />
        </svg>
    );
}

export default ZoomOutIcon;
